<template>
  <div id="app">
    <router-view/>
    <!-- 嵌套子网站 -->
    <div v-show="false">
      <!-- <iframe ref="zhihuifeng" src="https://www.zhihuifeng.com/free/index.html"></iframe>
      <iframe ref="campbell" src="https://www.campbellchina.com/free/index.html"></iframe>
      <iframe ref="smartsowo" src="https://www.smartsowo.com/free/sw.html"></iframe> -->
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'App',
  data () {
    return {

    }
  },
  computed: {
    ...mapState(['isLogin'])
  },
  methods: {
    freeLogin() {
      let params = {
        type: 'sa',
        params: {
          tk: this.$cookies.get("tokenWeb"),
          ui: this.$cookies.get("userInfo")
        }
      }
      this.$refs.zhihuifeng.contentWindow.postMessage(params, 'https://www.zhihuifeng.com');
      this.$refs.campbell.contentWindow.postMessage(params, 'https://www.campbellchina.com');
      this.$refs.smartsowo.contentWindow.postMessage(params, 'https://www.smartsowo.com');
    },
    clearCookie () {
      let params = {
        type: 'rm',
        params: {}
      }
      this.$refs.zhihuifeng.contentWindow.postMessage(params, 'https://www.zhihuifeng.com');
      this.$refs.campbell.contentWindow.postMessage(params, 'https://www.campbellchina.com');
      this.$refs.smartsowo.contentWindow.postMessage(params, 'https://www.smartsowo.com');
    }
  },
  watch: {
    isLogin (newVal) {
      if (newVal) {
        this.freeLogin()
      } else {
        this.clearCookie()
      }
    }
  }
}
</script>

<style>
#app {
  display: flex;
}
.container{
  width: 1200px !important;
  margin: 0 auto;
}
/* 面包屑 */
.brand{
  margin: 20px 0;
}
/* 暂无数据 */
.noValue{
  width: 100%;
  margin: 100px 0;
  font-size: 15px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue